import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, FormControl, FormGroup } from "@material-ui/core";
import CustomCheckbox from "../CustomCheckbox";
import translate from '../../other/translate.json';

export default function FilterShowCloudApps(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru';

  return (
    <Fragment>
      <FormControl component="fieldset" className={classes.root}>

        <FormGroup>
          <FormControlLabel key={'FormControlLabel1'}
            control={
              <CustomCheckbox
                checked={props.hasCloud === '1'}
                onChange={props.action}
              />
            }
            label={translate.Words[`HasCloudApps_${language}`]}
            className={classes.FClabel}
          />
        </FormGroup>
      </FormControl>
    </Fragment>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 285,
  },

  header: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  FClabel: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  }
}))